import { createFileRoute } from '@tanstack/react-router';
import { RequireMeasurements } from '../components/RequireMeasurements.js';
import { ColourStep } from '../steps/ColourStep.js';

export const Route = createFileRoute('/_planner/planner/colour')({
  component: () => (
    <RequireMeasurements requireLock allowUnverifiedCatalogue currentIndex={3}>
      <ColourStep />
    </RequireMeasurements>
  ),
});
